module.exports = __webpack_public_path__ + "app/img/bgContactUs.6d2ef6df.jpg";